
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email",
      function () {
        return require("private-next-pages/email.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email"])
      });
    }
  